export default "__VITE_ASSET__C$PTKmLB__"